// extracted by mini-css-extract-plugin
export default {"mangoTango":"#e17a00","subscribeLink":"#60bf02","channelLogoWidth":"68px","channelLogoRightPadding":"8px","thumbnailBorderThickness":"2px"};